import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import axios from 'axios';
import EnhancedTableHead, {
  Transition,
} from '../../components/Common/EnhancedTableHead';

import { Button, InputLabel, Select, MenuItem } from '@material-ui/core';
import { Delete, Edit } from '@material-ui/icons';
import WordOfTheDayDialog from './WordOfTheDayDialog';
import DeleteDailog from '../../components/Common/DeleteDailog';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import { baseUrl, languageId } from '../../helpers/EncryptionHelper';
import LoadIndicator from '../../components/Common/LoadIndicator';
import SearchBar from '../../components/Common/Search';
import dayjs from 'dayjs';

const headCells = [
  {
    id: 'words',
    numeric: false,
    disablePadding: false,
    label: 'words',
  },
  {
    id: 'Dates',
    numeric: false,
    disablePadding: false,
    label: 'Dates',
  },
  {
    id: 'actions',
    numeric: false,
    disablePadding: false,
    label: 'Actions',
    align: 'center',
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(3),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));

export default function CustomWordOfTheDay() {
  const classes = useStyles();
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('words');
  const [selected, setSelected] = useState([]);
  const [dense, setDense] = useState(false);

  const [openDailog, setOpenDailog] = useState(false);
  const [openDeleteDailog, setOpenDeleteDailog] = useState(false);
  const [editWordOfTheDay, setEditWordOfTheDay] = useState(false);
  const [selectedWordOfTheDay, setSelectedWordOfTheDay] = useState(false);

  const [rows, setRows] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [showLoader, setShowLoader] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchType, setSearchType] = useState('starts');
  const [currentPage, setCurrentPage] = useState(1);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleClose = () => {
    setEditWordOfTheDay(false);
    setSelectedWordOfTheDay();
    setOpenDailog(false);
  };

  function handleCloseDeleteDailog() {
    setSelectedWordOfTheDay();
    setOpenDeleteDailog(false);
  }

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const handleDelete = async () => {
    const idToDelete = selectedWordOfTheDay?._id || selectedWordOfTheDay?.id || selectedWordOfTheDay?.yoruba_wordofday_id;

    if (idToDelete) {
      axios
        .delete(baseUrl + `/wordofday/remove/${idToDelete}`)
        .then((res) => {
          if (res && res.data.status === 200) {
            handleCloseDeleteDailog();
            toastr.success('Word Of The Day Deleted Successfully', 'Success');
            fetchData((currentPage - 1) * limit, limit, searchTerm, searchType);
          }
        })
        .catch((err) => {
          toastr.error(`Word Of The Day removal Failed`, 'Error!');
        });
    } else {
      console.error('Unable to determine the ID for deletion');
    }
  };

  const handleCloseAndRefresh = () => {
    setEditWordOfTheDay(false);
    setOpenDailog(false);
    setSelected([]);
    setTimeout(() => {
      fetchData((currentPage - 1) * limit, limit, searchTerm, searchType);
    }, 200);
  };

  const fetchData = async (offset, limit, search = '', type = 'starts') => {
    setShowLoader(true);
    axios
      .get(
        baseUrl +
        `/wordofday/all?limit=${limit}&offset=${offset}&search=${search}&type=${type}&language=${languageId}`
      )
      .then((res) => {
        // Axios handles 200 and 304 as success by default
        const result = res.data;
        const data = result?.data || result; // Support both {data: {list}} and {list}

        if (res.status === 200 || res.status === 304 || result?.status === 200) {
          setRows(data?.list || data || []);
          setTotalCount(data?.totalCount || (data?.list ? data.list.length : (Array.isArray(data) ? data.length : 0)));
          setShowLoader(false);
        } else {
          // If status inside body is not 200 but axios didn't catch, check if we have data anyway
          if (data?.list || Array.isArray(data)) {
            setRows(data?.list || data);
            setTotalCount(data?.totalCount || (data?.list ? data.list.length : data.length));
          }
          setShowLoader(false);
        }
      })
      .catch((err) => {
        console.error('error fetching word of the day', err);
        setShowLoader(false);
      });
  };

  useEffect(() => {
    fetchData((currentPage - 1) * limit, limit, searchTerm, searchType);
  }, [limit, currentPage, searchTerm, searchType]);

  const totalPages = Math.ceil(totalCount / limit);

  const handleChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleSearch = (term) => {
    setSearchTerm(term);
    setCurrentPage(1);
  };

  const currentData = rows;

  return (
    <div className={classes.root}>
      <Button
        style={{
          backgroundColor: '#257b59',
          color: 'white',
          padding: 10,
          alignSelf: 'flex-end',
          marginBottom: 20,
        }}
        onClick={() => {
          setSelectedWordOfTheDay();
          setOpenDailog(true);
        }}
      >
        Add Word Of The Day
      </Button>
      <Paper className={classes.paper}>
        {showLoader ? (
          <LoadIndicator />
        ) : (
          <>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px', gap: '20px' }}>
              <div>
                <InputLabel id="search-type-label">Search Type</InputLabel>
                <Select
                  labelId="search-type-label"
                  id="search-type-select"
                  value={searchType}
                  onChange={(e) => {
                    setSearchType(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <MenuItem value={'starts'}>Starts with</MenuItem>
                  <MenuItem value={'contains'}>Contains</MenuItem>
                  <MenuItem value={'match'}>Exact Match</MenuItem>
                </Select>
              </div>
              <div style={{ flex: 1 }}>
                <SearchBar value={searchTerm} onSearch={handleSearch} />
              </div>
            </div>
            <TableContainer>
              <Table
                className={classes.table}
                aria-labelledby='tableTitle'
                size={dense ? 'small' : 'medium'}
                aria-label='enhanced table'
              >
                <EnhancedTableHead
                  classes={classes}
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={rows.length}
                  headCells={headCells}
                />
                <TableBody>
                  {currentData.map((row, index) => {
                    return (
                      <TableRow hover tabIndex={-1} key={index}>
                        <TableCell align='left'>
                          {row.wordName || row.word_name || row.yoruba_word_name || 'NA'}
                        </TableCell>
                        <TableCell align='left'>
                          {row.show_at ? dayjs(row.show_at).format('DD/MM/YYYY') : 'NA'}
                        </TableCell>
                        <TableCell width={'30%'} align='center'>
                          <IconButton
                            variant='contained'
                            style={{ color: '#ddd' }}
                            onClick={() => {
                              setEditWordOfTheDay(true);
                              setSelectedWordOfTheDay(row);
                              setOpenDailog(true);
                            }}
                          >
                            <Edit />
                          </IconButton>
                          <IconButton
                            variant='contained'
                            style={{ color: '#ddd' }}
                            onClick={() => {
                              setOpenDeleteDailog(true);
                              setSelectedWordOfTheDay(row);
                            }}
                          >
                            <Delete />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {rows.length === 0 && (
                    <TableRow style={{ height: (dense ? 33 : 53) * limit }}>
                      <TableCell colSpan={6} align="center">No data found</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
              <Stack spacing={2}>
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={handleChange}
                  color="primary"
                  variant="outlined" shape="rounded"
                />
              </Stack>
            </div>
          </>
        )}
      </Paper>
      <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label='Dense padding'
      />

      {openDailog && (
        <WordOfTheDayDialog
          data={selectedWordOfTheDay}
          visible={openDailog}
          handleClose={handleClose}
          Transition={Transition}
          editWordOfTheDay={editWordOfTheDay}
        />
      )}
      {openDeleteDailog && (
        <DeleteDailog
          data={selectedWordOfTheDay}
          visible={openDeleteDailog}
          handleClose={handleCloseDeleteDailog}
          Transition={Transition}
          dialogTitle={() => (
            <div className='mt-3'>
              Do you want to delete this Word of the Day entry :{' '}
              <strong>{selectedWordOfTheDay?.wordName || selectedWordOfTheDay?.word_name || selectedWordOfTheDay?.yoruba_word_name || 'NA'}</strong>
            </div>
          )}
          handleDeleteClicked={() => handleDelete()}
        />
      )}
    </div>
  );
}
